import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ng2-bootstrap/components/tabs';

import { SlimScrollModule } from 'ng2-slimscroll';
import { CreateGroupComponent } from './create-group/create-group.component';
import { GroupListComponent } from './group-list/group-list.component';
import { DisableGroupComponent } from './disable-group/disable-group.component';
import { EditGroupComponent } from './edit-group/edit-group.component';
import { ManageGroupComponent } from './manage-group/manage-group.component';
import { GroupRoutingModule } from './group-routing.module';
import { SharedModule } from './../shared/shared.module';
import { LinkActivitiesPopupComponent } from './create-group/link-activities/link-activities.component';

@NgModule({
  imports: [
    CommonModule,
    GroupRoutingModule,
    SharedModule,
    SlimScrollModule,
    TabsModule
  ],
  declarations: [CreateGroupComponent, GroupListComponent, DisableGroupComponent, EditGroupComponent, ManageGroupComponent, LinkActivitiesPopupComponent]
})
export class GroupModule { }



// WEBPACK FOOTER //
// ./src/app/group/group.module.ts